// extracted by mini-css-extract-plugin
export var divider = "_v0-0";